import { Component, Input } from '@angular/core';
import { AvailabilityMonth } from '../../users/availability-edit/availability-month.model';
import { AvailabilityWeek } from '../../users/availability-edit/availability-week.model';
import { PoolerUser } from 'server/shared/models/user';

@Component({
  selector: 'app-availability-month-item',
  templateUrl: 'availability-month-item.component.html',
  styleUrls: ['availability-month-item.component.scss'],
})
export class AvailabilityMonthItemComponent {
  @Input() month?: AvailabilityMonth;
  @Input() user?: PoolerUser;
  @Input() expanded?: boolean;

  constructor() {}

  toggleMonthCollapsed(event?: Event): void {
    if (event) {
      event.stopPropagation();
    }
    this.expanded = !this.expanded;
  }

  trackByStartDateString(_: number, week: AvailabilityWeek): string {
    return week.startDateString;
  }
}
